import { BasicButton, BasicInput, SelectComponent, SwitchComponent } from 'Common/Components';
import Modal from 'Common/Components/Modal';
import { useTranslation } from 'react-i18next';
import { useWarehouseStore } from '../store/useWarehouseStore';
import { useAddWarehouse } from '../hooks/useAddWarehouse';
import { getDefaultValueForSelect } from 'helpers/functionsHelpers';

export const ModalFormCreateWarehouse = () => {
  const {
    isOpenModalWarehouse,
    handleCloseModalWarehouse,
    setIsEdit,
    isEdit,
    setWarehouse,
  } = useWarehouseStore();
  const { t } = useTranslation();
  const { formik, optionBranch, valueBranch } = useAddWarehouse();
  
  return (
    <Modal
      show={isOpenModalWarehouse}
      onHide={() => {
        handleCloseModalWarehouse();
        setWarehouse(null);
        setIsEdit(false);
        formik.resetForm();
      }}
      id='defaultModal'
      modal-center='true'
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1050] flex flex-col transition-all duration-300 ease-in-out"
      dialogClassName='w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600'
    >
      <Modal.Header
        className='flex items-center justify-between p-4 border-b dark:border-zink-300/20'
        closeButtonClass='transition-all duration-200 ease-linear text-slate-400 hover:text-red-500'
      >
        <Modal.Title className='text-16'>
          {!!isEdit
            ? t('CrudWarehouse.edit')
            : t('CrudWarehouse.addNewOptionBtn')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className='mt-1'
          id='signInForm'
          onSubmit={(event) => {
            event.preventDefault();
            formik.handleSubmit();
          }}
        >
          <BasicInput
            label={t('CrudWarehouse.form.labelDescription')}
            placeholder={t('CrudWarehouse.form.inputDescription')}
            id='description'
            name='description'
            type='text'
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={
              !!(formik.touched.description && formik.errors.description)
            }
            errorMessage={formik.errors.description || ''}
          ></BasicInput>
          <div className='flex justify-between my-2'>
            <label className='inline-block mb-2 text-base font-medium'>
              {t('CrudWarehouse.form.labelMainSeconday')}
            </label>
            <SwitchComponent
              isOn={formik.values.main_warehouses === 1}
              onChange={(checked: boolean) =>
                formik.setFieldValue('main_warehouses', checked ? 1 : 0)
              }
              disabled={formik.isSubmitting}
              size='medium'
              className=''
            />
            <label className='inline-block mb-2 text-base font-medium'>
              {t('CrudWarehouse.form.labelMain')}
            </label>
          </div>

          <div className='col-span-6'>
            <SelectComponent
              label={t('CrudWarehouse.form.labelBranch')}
              id='user_type'
              placeholder={t('CrudWarehouse.form.inputBranch')}
              options={optionBranch}
              isMulti={false}
              onChange={(e) => formik.setFieldValue('branch_id', e.value)}
              onBlur={formik.handleBlur}
              value={valueBranch}
              defaultValue={getDefaultValueForSelect(
                optionBranch,
                formik.values.branch_id.toString()
              )}
            ></SelectComponent>
          </div>
          <div className='col-span-12'>
            <div className='flex justify-end'>
              <BasicButton
                disabled={formik.isSubmitting}
                type='submit'
                onClick={() => { }}
              >
                <span className='text-white'>
                  {isEdit
                    ? t('CrudWarehouse.edit')
                    : t('CrudWarehouse.addNewOptionBtn')}
                </span>
              </BasicButton>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
